"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketEventType = void 0;
var WebSocketEventType;
(function (WebSocketEventType) {
    WebSocketEventType["WEBSOCKET_SERVICE_READY"] = "WebsocketServiceReady";
})(WebSocketEventType = exports.WebSocketEventType || (exports.WebSocketEventType = {}));
